
import { ExitIntentTemplates } from "./exitIntentTemplatesData";
export let formData = {
    campaignName: "New Campaign",
    delay: {                    // Default value for delay is 2 Sec.
        duration: "2",
        durationType: "SECONDS"
    },
    disappear: {
        status: false,
        duration: "15",
        durationType: "SECONDS"
    },
    interval: {
        duration: "5",          // Default value for interval is 5 Mins.
        durationType: "MINUTES"
    },
    markup: "",
    actionProps: {
        "emailSubscriptionForm": {
            "cssTemplateId": "MKTEXITINTENTTEMP0",
            "animation": '',
            /*"overlayfields": {
                "email": true,
                "phone": true
            },*/
            "overlayfields": ExitIntentTemplates['MKTEXITINTENTTEMP0']?.overlayfields,
            "heading": {
                "show": ExitIntentTemplates['MKTEXITINTENTTEMP0']?.heading?.show,
                "text": "Enter heading text here...",
                "color": "",
                "colorMode": "hex",
                "fontsize": ""
            },
            "subheading": {
                "show": ExitIntentTemplates['MKTEXITINTENTTEMP0']?.subheading?.show,
                "fontsize": "",
                "color": "",
                "colorMode": "hex",
                "text": "Enter subheading text here..."
            },
            "confirmButton": {
                "show": ExitIntentTemplates['MKTEXITINTENTTEMP0']?.confirmButton?.show,
                "content": {
                    "text": "I'm In",
                    "color": "",
                    "colorMode": "hex",
                },
                "background": {
                    "color": "",
                    "colorMode": "rgba"
                }
            },
            "consentMsg": {
                "text": "By signing up,you agree to recieve recurring automated marketing text.",
                "show":  ExitIntentTemplates['MKTEXITINTENTTEMP19']?.consentMsg?.show,
                "status": false,
                "color": "#ffffff",
                "colorMode": "hex",
                "fontsize": "15"
            },
            "cancelButton": {
                "show": ExitIntentTemplates['MKTEXITINTENTTEMP0']?.cancelButton?.show,
                "content": {
                    "text": "No, Thanks",
                    "color": "",
                    "colorMode": "hex"
                },
                "background": {
                    "color": "",
                    "colorMode": "rgba"
                }
            },
            "logo": {
                "show": true,
                "url": "",
                "position": "center"
            },
            "background": {
                "color": "",
                "colorMode": "rgba"
            },
            "redirect": {
                "status": false,
                "url": "",
                "isURL": null
            },
            "endpoint": {
                "status": false,
                "url": ""
            }

        },
        "urlTargeting": {
            "choice": "ALL",    // ALL/SPECIFIC
            "globalOperator": "OR", // OR/AND
            "criteria": [],
            "utmParameters": {}
        },
        "scroll": {
            "status": false,
            "percentage": 50
        },
        "timeBasedTargeting": {
            "status": false,
            "duration": 15,
            "durationType": "SECONDS"
        },

        //"userTargeting": "all",
        "usersTargeting": {
            "userType": "all",  // all, returning, new
            "showToMappedUsers": false
        },
        "locationAndSystemTargeting": {
            "status": false,
            "globalOperator": "AND", // OR/AND
            "criteria": []
        },
        "integrations": {
            "emailServiceProviders": []
        },
        "device": {
            "screen" : {
                "mobile" : {
                    "show": true
                },
                "tablet" : {
                    "show": true
                },
                "desktop" : {
                    "show": true
                }
            }
        },
        "events": {
            "enabled": false,
            "primaryEvents": []
        },
        "fireEvents":{
            "enabled":false,
            "eventName":"",
            "eventValue":""
        },
        "customTemplate": {
            "html": "",
            "css": "",
            "height": "500px",
            "width": "700px",
            "endpoint": "",
            "redirect": {
                "status": false,
                "url": ""
            },
            "background" : {
                "color": "#fff",
                "colorMode": "hex"
            }
        }
    },
    step2Fields: {
        enabled: false,
        "heading": {
            "text": "Enter heading text here...",
            "color": "",
            "colorMode": "hex",
            "fontsize": "",
            "show": true
        },
        "subheading": {
            "fontsize": "",
            "color": "",
            "colorMode": "hex",
            "text": "Enter subheading text here...",
            "show": true
        },
        "confirmButton": {
            "content": {
                "text": "I'm In",
                "color": "",
                "colorMode": "hex"
            },
            "background": {
                "color": "",
                "colorMode": "rgba"
            },
            "show": true
        },
        "consentMsg": {
            "text": "By signing up,you agree to recieve recurring automated marketing text.",
            "show": ExitIntentTemplates['MKTEXITINTENTTEMP29']?.step2Fields?.consentMsg?.show,
            "status": false,
            "color": "#ffffff",
            "colorMode": "hex",
            "fontsize": ""
        },
        "cancelButton": {
            "content": {
                "text": "No, Thanks",
                "color": "",
                "colorMode": "hex"
            },
            "background": {
                "color": "",
                "colorMode": "rgba"
            },
            "show": true
        },
        "background": {
            "color": "",
            "colorMode": "rgba",
            "show": true
        },
        "logo": {
            "show": true,
            // "url": $rootScope.absoluteURL+"assets/img/your-logo.png",
            "position": "center"
        },
        "fortuneWheel" : {
            "show" : ExitIntentTemplates['MKTEXITINTENTTEMP31']?.step2Fields?.fortuneWheel?.show,
            "colorMode": "hex",
            "emailConfig":{
                "templateUuid": "",
                "sendEmail": false
            },
            "fortuneWheelData" : []
        },
    },
    "absoluteUrl" : process.env.REACT_APP_API_ENDPOINT
};